import Technology from "./ApplicationService";

export default Technology;
